import { render, staticRenderFns } from "./Fanzones-roadtours.vue?vue&type=template&id=8f23ce28&"
import script from "./Fanzones-roadtours.vue?vue&type=script&lang=js&"
export * from "./Fanzones-roadtours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports